// extracted by mini-css-extract-plugin
export default {"tasks":"xM-z","task":"yM-z","svg":"zM-z","text":"AM-z"};